import { Box } from 'ui';

import { useMatchedSiteMaterialItem } from '../../contexts/MatchedSiteMaterialItemContext';
import { NetTakeRateOverview } from '../NetTakeRateOverview/NetTakeRateOverview';

export const DealMarginDrawerSection = () => {
  const { totalNetTakeRate, targetMargin } = useMatchedSiteMaterialItem();

  return (
    <Box display="flex">
      <NetTakeRateOverview totalNetTakeRate={totalNetTakeRate} targetMargin={targetMargin} />
    </Box>
  );
};
